'use client';

import QueryString from 'qs';

import { useRunOnce } from '@/presenters/hooks/use-run-once';

interface SketchFabPlayerProps {
  modelId: string;
  className?: string;
  onStart?: () => void;
}

function SketchFabPlayer(props: Readonly<SketchFabPlayerProps>) {
  const { modelId, className, onStart } = props;

  const options = {
    autostart: 1,
    camera: 0,
    ui_animations: 0,
    ui_infos: 0,
    ui_stop: 0,
    ui_inspector: 0,
    ui_watermark_link: 0,
    ui_watermark: 0,
    ui_ar: 0,
    ui_help: 0,
    ui_settings: 0,
    ui_vr: 0,
    ui_fullscreen: 1,
    ui_annotations: 0,
  };

  useRunOnce(() => {
    if (onStart) {
      onStart();
    }
  }, Boolean(onStart));

  return (
    <iframe
      title="sketchFabModel"
      allowFullScreen
      src={`https://sketchfab.com/models/${modelId}/embed?${QueryString.stringify(
        options
      )}`}
      className={className}
    />
  );
}

export default SketchFabPlayer;
